import { Fragment, useState } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import { Mail, Phone, MapPin, Clock, CheckCircle } from "lucide-react";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  /* ===================== HANDLE CHANGE ===================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "fullName") {
      const filteredValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormData({ ...formData, [name]: filteredValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  /* ===================== VALIDATION ===================== */
  const validate = () => {
    let newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ===================== SUBMIT ===================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/contact-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (data.success) {
        setIsSubmitted(true);

        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({
            fullName: "",
            email: "",
            subject: "",
            message: "",
          });
        }, 5000);
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Contact API Error:", error);
      alert("Server error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Header />

      <main className="kks-dark-wrapper">
        <div className="kks-contact-container">
          <div className="kks-main-card">

            <div className="kks-header-section">
               
              <h3 style={{ color: "#ffffffff",fontSize: "40px" }}>Contact Us</h3>
              <p className="kks-desc"> We're here to help. Send us a message and we'll respond as soon as possible.</p>
            </div>

            <div className="kks-grid">
              {/* ===================== FORM ===================== */}
              <div className="kks-form-area">
                <h3 style={{ color: "#fff" }}>Send a Message</h3>

                {isSubmitted ? (
                  <div className="kks-success-banner">
                    <CheckCircle size={40} color="#4bb543" />
                    <h4 style={{ color: "#fff" }}>Message Sent!</h4>
                    <p style={{ color: "#fff" }}>Thank you, {formData.fullName}. We will get back to you shortly.</p>
                    <button
                      onClick={() => setIsSubmitted(false)}
                      className="kks-reset-btn"
                    >
                      Send another message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="kks-form-row">
                      <div className="kks-input-group">
                        <label>Full Name</label>
                        <input
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          placeholder="John Doe"
                        />
                        {errors.fullName && (
                          <span className="kks-error-msg">{errors.fullName}</span>
                        )}
                      </div>

                      <div className="kks-input-group">
                        <label>Email Address</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="example@email.com"
                        />
                        {errors.email && (
                          <span className="kks-error-msg">{errors.email}</span>
                        )}
                      </div>
                    </div>

                    <div className="kks-input-group">
                      <label>Subject</label>
                      <input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="How can we help?"
                      />
                    </div>

                    <div className="kks-input-group">
                      <label>Message</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="5"
                        placeholder="Your message..."
                      />
                    </div>

                    <button
                      type="submit"
                      className="kks-submit-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Send Message"}
                    </button>
                  </form>
                )}
              </div>

              {/* ===================== INFO ===================== */}
              <div className="kks-info-area"style={{ marginTop: '120px' }}>
                <div className="kks-info-item">
                  <div className="kks-icon-box"><Phone size={20} /></div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+91 9866673323</p>
                    <span><Clock size={12} /> Mon-Sat, 9am - 6pm</span>
                  </div>
                </div>
                

                <div className="kks-info-item">
                  <div className="kks-icon-box"><Mail size={20} /></div>
                  <div>
                    <h4>Email Support</h4>
                    <p>Kalakakshaaha@gmail.com</p>
                  </div>
                </div>
                  
                  <div className="kks-info-item">
                  <div className="kks-icon-box"><MapPin size={20} /></div>
                  <div>
                    <h4>Our Address</h4>
                   
                    
                    <p> <h6 style={{ color: "#ffcc00", fontSize: "15px" }}>VKAKSHAAHA EDUINSTITUTIONS LLP</h6>  H.No.16-11-511/D/97/20,
                       Flat no:4,Shalivahana Complex, 
                       Dilsukhnagar Colony,
                       K.V.Rangareddy,Saroornagar,
                       Telangana,India,500060</p>
                  </div>
                </div>



               {/* <div className="kks-info-item">
                  <div className="kks-icon-box"><MapPin size={20} /></div>
                  <div>
                    <h4>Location</h4>
                    <p>Hyderabad / Bengaluru</p>
                   
                  </div>
                </div>*/}
              </div>
            </div>

            {/* ===================== MAP ===================== */}
            <div className="kks-location-section">
               <div className="location-header" style={{ color: '#fff', marginTop: '20px' }}>
                
                {/*<h3 style={{ color: '#fff' }}>  <MapPin size={28} className="pin-icon" />   Our Location</h3>*/}
              </div>
              <div className="map-container">
                {/*<iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.316040705!2d78.26795864115206!3d17.4122998016912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc1!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
                  width="100%" 
                  height="350" 
                  style={{ border: 0, borderRadius: '15px' }} 
                  allowFullScreen="" 
                  loading="lazy"
                ></iframe>*/}
              </div>
            </div>
          </div>
        </div>

        <style>
{`
@media (max-width: 768px) {
 
  .kks-info-area {
    margin-top: 0 !important;
  }
 
  .kks-main-card {
    padding: 30px !important;
  }
 
}
`}
</style>
      </main>

      <Footer />
    </Fragment>
  );
};

export default ContactPage;
